module.exports = __webpack_public_path__ + "15217f5876516d4024c3150a75f65f0a.svg";